import { type StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import { css } from '@repo/pandacss/styled-system/css';
import { MdCheck, MdClose } from 'react-icons/md';
import { PanelColumn } from './PanelColumn';

type Props = {
  prosList?: string[] | StructuredContentDocument[];
  consList?: string[] | StructuredContentDocument[];
};

export function PanelProsAndCons({ prosList, consList }: Props) {
  const hasPros = !!prosList?.length;
  const hasCons = !!consList?.length;

  if (!hasPros && !hasCons) return null;

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: { base: 'column', sm: 'row' },
        columnGap: '4',
        rowGap: '4',
      })}
    >
      {hasPros && <PanelColumn title="Pros" items={prosList} colorScheme="green" Icon={MdCheck} />}
      {hasCons && <PanelColumn title="Cons" items={consList} colorScheme="red" Icon={MdClose} />}
    </div>
  );
}
